export enum Slices {
  AuthSlice = 'auth',
  ToastSlice = 'toast',
  RoutesSlice = 'routes',
}

export interface ISlices {
  [Slices.AuthSlice]: string;
  [Slices.ToastSlice]: string;
  [Slices.RoutesSlice]: string;
}

export const toastDivID = 'toast';

export enum CreateSurveyCardsNames {
  contents = 'contents',
  schedule = 'schedule',
  results = 'results',
  participantsandreports = 'participantsandreports',
  shareResults = 'shareResults',
  dashboard = 'dashboard',
}

export enum CreateSurveyTypeNames {
  internal = 'internal',
  external = 'external',
  participants = 'participants',
  reportsSetup = 'reportsSetup',
  overview = 'overview',
  departments = 'departments',
}

export enum ReportViewCardsNames {
  results = 'results',
  insights = 'insights',
  groupComparison = 'groupComparison',
  recommendation = 'recommendation',
  resources = 'resources',
  internal = 'internal',
  external = 'external',
  externalResults = 'externalResults',
  openComments = 'openComments',
}
